import { getActiveCountry, translate } from '@openclassrooms/translations';
import {
  getConfigurationCountry,
  getLocalisationConfig,
} from '@openclassrooms/localisation/services';

import { SlotNames } from './blueshift';
import type { SlotNamesToDatas } from '..';

const DATA_EVENT_TYPE = 'Banner';
const DATA_EVENT_CATEGORY = 'Clicked::Top';
const DATA_EVENT_ACTION = 'Promobar';

const getMarketingStaticContent = <T extends SlotNames>(slot: T): SlotNamesToDatas[T] => {
  const STATIC_CONTENTS = [
    {
      slotName: SlotNames.PopUp,
      slotDatas: [
        {
          show: false,
          content: {
            matchingUrl: '(/fr/|/fr|/fr/[^a-zA-Z0-9].*)$',
            isMatchingUrlRegExp: true,
            storageKey: 'TEST',
            title: 'Préparez vos équipes aux enjeux de demain !',
            subheading:
              'Plus de 1 900 entreprises font confiance à OpenClassrooms pour accompagner la montée en compétences de leurs équipes.',
            bullet_1: '20% théorie',
            bullet_2: '70% pratique',
            bullet_3: '100% en ligne',
            firstButton: {
              label: 'Lorem',
              url: '#lorem',
              variant: 'primary',
              isTargetBlank: false,
              dataEvent: {
                type: 'PopUp CTA',
                category: 'Clicked::PopUp',
                action: 'PopUp click',
                label: 'First link',
              },
            },
            secondButton: {
              label: 'Test',
              url: '#test',
              isTargetBlank: false,
              dataEvent: {
                type: 'PopUp CTA',
                category: 'Clicked::PopUp',
                action: 'PopUp click',
                label: 'Second link',
              },
            },
            mediaUrl: 'https://cdn.getblueshift.com/pictures/268189/content/popup_img.png',
          },
        },
      ],
    },
    {
      slotName: SlotNames.NewFeature,
      slotDatas: [],
    },
    {
      slotName: SlotNames.TopBanner,
      slotDatas: [
        {
          show: true,
          content: {
            body: translate('predictive_crm.top_banner.global_page.body'),
            button: translate('predictive_crm.top_banner.global_page.button'),
            link: translate('predictive_crm.top_banner.global_page.link'),
            matchingUrl: '(/fr|/en|/fr/|/en/|/dashboard/[^a-zA-Z0-9].*)',
            isMatchingUrlRegExp: true,
            dataEvent: {
              type: DATA_EVENT_TYPE,
              category: DATA_EVENT_CATEGORY,
              action: DATA_EVENT_ACTION,
            },
          },
        },
        {
          show:
            getLocalisationConfig('jobOffers.isEnabled') &&
            getLocalisationConfig('apprenticeship.isEnabled'),
          content: {
            body: translate('predictive_crm.top_banner.home.body'),
            button: translate('predictive_crm.top_banner.home.button'),
            link: translate('predictive_crm.top_banner.home.link'),
            matchingUrl: '(/fr/|/fr|/fr/[^a-zA-Z0-9].*)$',
            isMatchingUrlRegExp: true,
            dataEvent: {
              type: DATA_EVENT_TYPE,
              category: DATA_EVENT_CATEGORY,
              action: DATA_EVENT_ACTION,
            },
            isTargetBlankLink: true,
          },
        },
        {
          show: true,
          content: {
            body: translate('predictive_crm.top_banner.funding.body'),
            button: translate('predictive_crm.top_banner.funding.button'),
            link: translate('predictive_crm.top_banner.funding.link'),
            matchingUrl: '(/fr/funding)',
            isMatchingUrlRegExp: true,
            dataEvent: {
              type: DATA_EVENT_TYPE,
              category: DATA_EVENT_CATEGORY,
              action: DATA_EVENT_ACTION,
            },
            isTargetBlankLink: true,
          },
        },
        {
          show: true,
          content: {
            body: translate('predictive_crm.top_banner.apprenticeship.body'),
            button: translate('predictive_crm.top_banner.apprenticeship.button'),
            link: translate('predictive_crm.top_banner.apprenticeship.link'),
            matchingUrl: '(/fr/apprenticeship)',
            isMatchingUrlRegExp: true,
            dataEvent: {
              type: DATA_EVENT_TYPE,
              category: DATA_EVENT_CATEGORY,
              action: DATA_EVENT_ACTION,
            },
            isTargetBlankLink: true,
          },
        },
        {
          show: getConfigurationCountry(getActiveCountry()) === 'FR',
          content: {
            body: translate('predictive_crm.top_banner.business.body'),
            button: translate('predictive_crm.top_banner.business.button'),
            link: translate('predictive_crm.top_banner.business.link'),
            matchingUrl: '(/fr/business)$',
            isMatchingUrlRegExp: true,
            dataEvent: {
              type: DATA_EVENT_TYPE,
              category: DATA_EVENT_CATEGORY,
              action: DATA_EVENT_ACTION,
            },
            isTargetBlankLink: true,
          },
        },
        {
          show: true,
          content: {
            body: translate('predictive_crm.top_banner.forume.body'),
            button: translate('predictive_crm.top_banner.forum.button'),
            link: translate('predictive_crm.top_banner.forum.link'),
            matchingUrl: '(/forum/)$',
            isMatchingUrlRegExp: true,
            dataEvent: {
              type: DATA_EVENT_TYPE,
              category: DATA_EVENT_CATEGORY,
              action: DATA_EVENT_ACTION,
            },
          },
        },
        {
          show: false,
          content: {
            body: translate('predictive_crm.top_banner.home_dashboard.body'),
            button: translate('predictive_crm.top_banner.home_dashboard.button'),
            link: translate('predictive_crm.top_banner.home_dashboard.link'),
            matchingUrl: '(/fr/dashboard/courses)$',
            isMatchingUrlRegExp: true,
            dataEvent: {
              type: DATA_EVENT_TYPE,
              category: DATA_EVENT_CATEGORY,
              action: DATA_EVENT_ACTION,
            },
          },
        },
      ],
    },
  ];

  return STATIC_CONTENTS.find((content) => content.slotName === slot) as SlotNamesToDatas[T];
};
export default getMarketingStaticContent;
